export const navigationLinks = [
  { label: "Services", href: "#services", testId: "header-nav-services-link" },
  { label: "About", href: "#about-rebecca", testId: "header-nav-about-link" },
  { label: "Profile", href: "#corporate-profile", testId: "header-nav-profile-link" },
  { label: "Coverage", href: "#regional-coverage", testId: "header-nav-coverage-link" },
  { label: "Past Events", href: "#past-events", testId: "header-nav-past-events-link" },
  { label: "Portfolio", href: "#portfolio", testId: "header-nav-portfolio-link" },
  { label: "FAQ", href: "#faq", testId: "header-nav-faq-link" },
  { label: "Consult", href: "#consultation", testId: "header-nav-consult-link" },
];

export const heroImage = "https://images.unsplash.com/photo-1719432270124-5c1327c63747?auto=format&fit=crop&w=1800&q=85";
export const heroImageAlt = "Abstract purple corporate gradient background";
export const baseMapImage = "https://images.unsplash.com/photo-1713098965471-d324f294a71d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHx3b3JsZCUyMG1hcHxlbnwwfHx8fDE3NzYyMzEwODd8MA&ixlib=rb-4.1.0&q=85";
export const rateCardUrl = "https://customer-assets.emergentagent.com/job_bookings-events-io/artifacts/blle1vrs_RL%20Rate%20Card%20Events.pdf";
export const cvUrl = "https://customer-assets.emergentagent.com/job_bookings-events-io/artifacts/xe473nfd_Rebecca%20Learoyd%2C%20CV%202026%20.pdf";

export const services = [
  {
    title: "Conference Production + Speaker Acquisition",
    group: "Primary",
    description: "Strategic conference production with integrated speaker sourcing, outreach, and session operations.",
    price: "Detailed fee structure in rate card",
    highlights: ["Agenda + session design", "Speaker sourcing + onboarding", "Run of show + stage timing"],
  },
  {
    title: "Event Management",
    group: "Primary",
    description: "End-to-end event operations covering venue, vendors, budgeting, logistics, and day-of control.",
    price: "Detailed fee structure in rate card",
    highlights: ["Venue + vendor management", "Budget + timeline control", "On-site delivery leadership"],
  },
  {
    title: "Master of Ceremony",
    group: "Primary",
    description: "Professional corporate emcee services with script development, moderation, and audience engagement.",
    price: "Detailed fee structure in rate card",
    highlights: ["On-stage hosting", "Script rehearsal", "Panel moderation + Q&A"],
  },
  {
    title: "Content + Event Marketing",
    group: "Secondary",
    description: "Pre-event promotions, event-day content planning, and post-event amplification for measurable reach.",
    price: "Custom quote",
    highlights: ["Content planning", "Registration growth campaigns", "Performance reporting"],
  },
];

export const aboutRebecca = {
  name: "Rebecca J. Learoyd",
  role: "Pan-Asia Corporate Event Strategist & Producer",
  summary:
    "Rebecca Learoyd is a results-driven corporate event professional with 10+ years of experience delivering conferences and executive forums across Asia and Oceania. She provides Pan-Asia corporate event services based in Hong Kong, combining strategic planning, commercial awareness, and operational precision to build events that strengthen brand authority and business outcomes. Her work covers the full event lifecycle, from market-led agenda development and speaker acquisition through partner activation, audience growth, and on-site production. Rebecca is known for leading complex stakeholder environments with calm control while maintaining high standards for attendee experience, budget discipline, and delivery quality. She has consistently helped event portfolios scale in attendance and market impact through data-informed campaign strategy, strong sponsor alignment, and premium execution.",
  points: [
    "Increased event attendance by 20% across a portfolio of 17 events in Asia and Oceania.",
    "Launched and scaled a new event brand to 300% growth over a three-year period.",
    "Secured high-profile speakers and delivered campaign performance with email open rates above 10%.",
  ],
};

export const corporateProfile = {
  heading: "Corporate Profile",
  subtitle: "Executive-ready summary for Pan-Asia procurement and event stakeholders",
  profileHighlights: [
    "Pan-Asia corporate event services, based in Hong Kong",
    "10+ years delivering conferences and executive events across Asia and Oceania",
    "50+ events delivered across entire career",
    "Portfolio attendance growth of 20% across 17 events",
    "Scaled a new event brand to 300% growth over 3 years",
    "Strong track record in speaker acquisition, sponsor alignment, and event ROI",
  ],
};

export const trustMetrics = [
  { label: "Years Experience", value: "10+", context: "Corporate events across Asia & Oceania" },
  { label: "Portfolio Events", value: "50+", context: "Events delivered across entire career" },
  { label: "Attendance Growth", value: "+20%", context: "Measured uplift across managed events" },
  { label: "Brand Scale Growth", value: "300%", context: "New event brand growth over 3 years" },
];

export const seoContent = {
  heading: "Pan-Asia Corporate Event Management, based in Hong Kong",
  body: "RJL Events HK delivers Pan-Asia corporate event management services for conferences, summits, leadership forums, and product launches. Based in Hong Kong, Rebecca leads strategy, speaker acquisition, event production, and on-site execution across major regional markets including Singapore, Tokyo, India, and Australia.",
};

export const coverageMarkets = [
  { name: "Hong Kong", focus: "Operating Hub", lat: 22.3193, lng: 114.1694 },
  { name: "Singapore", focus: "Southeast Asia", lat: 1.3521, lng: 103.8198 },
  { name: "Tokyo", focus: "North Asia", lat: 35.6762, lng: 139.6503 },
  { name: "Mumbai", focus: "India West", lat: 19.076, lng: 72.8777 },
  { name: "Bangalore", focus: "India South", lat: 12.9716, lng: 77.5946 },
  { name: "Sydney", focus: "Australia East", lat: -33.8688, lng: 151.2093 },
  { name: "Melbourne", focus: "Australia South", lat: -37.8136, lng: 144.9631 },
];

export const regionalDeliveryModel = [
  {
    stage: "01 · Regional Strategy",
    detail: "Define goals, audience, and KPI framework with one central plan across all target markets.",
  },
  {
    stage: "02 · Market Localization",
    detail: "Adapt messaging, speakers, and production format to local market context while keeping brand consistency.",
  },
  {
    stage: "03 · Central PMO + Local Execution",
    detail: "Run one central command structure with local vendor, venue, and stakeholder coordination in each location.",
  },
  {
    stage: "04 · Delivery & Reporting",
    detail: "Execute on-site with controlled run-of-show, then consolidate post-event insights and ROI reporting.",
  },
];

export const portfolioItems = [
  {
    title: "Leadership Summit & Awards Night",
    category: "Corporate",
    image:
      "https://images.unsplash.com/photo-1753030722011-c50785aa569b?auto=format&fit=crop&w=1200&q=85",
  },
  {
    title: "Black-Tie Corporate Gala",
    category: "Corporate",
    image:
      "https://images.unsplash.com/photo-1768508947591-b650dacc70a4?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    title: "Product Launch Experience",
    category: "Corporate",
    image:
      "https://images.unsplash.com/photo-1768508950408-d59387d4dcd1?auto=format&fit=crop&w=1200&q=85",
  },
  {
    title: "Executive Conference Series",
    category: "Corporate",
    image:
      "https://images.unsplash.com/photo-1606744038221-5e0fa1c68fe6?auto=format&fit=crop&w=1200&q=85",
  },
];

export const testimonials = [
  {
    quote:
      "They handled our full executive summit, speaker logistics, and emcee flow with absolute precision.",
    name: "Leena Patel",
    event: "Global Leadership Summit",
    avatar:
      "https://images.unsplash.com/photo-1758599543111-36ce5c34fceb?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    quote:
      "Content creation and marketing support helped us sell out our flagship conference ahead of schedule.",
    name: "Marcus Hill",
    event: "Corporate Conference",
    avatar:
      "https://images.unsplash.com/photo-1651684215020-f7a5b6610f23?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    quote:
      "The planning framework, operations discipline, and emcee performance gave our annual forum a polished executive feel.",
    name: "Nadia Brooks",
    event: "Annual Executive Forum",
    avatar:
      "https://images.unsplash.com/photo-1758518727888-ffa196002e59?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const faqItems = [
  {
    question: "What types of corporate events do you manage?",
    answer:
      "We focus on conferences, leadership summits, product launches, partner events, and gala evenings with full production and operations support across Pan-Asia markets.",
  },
  {
    question: "Can you handle speaker acquisition and management?",
    answer:
      "Yes. Speaker acquisition is integrated into our conference production process, covering outreach, coordination, and session readiness.",
  },
  {
    question: "Do you provide event marketing and content generation?",
    answer:
      "Absolutely. We offer pre-event promotions, social media content, live event coverage coordination, and post-event recap content.",
  },
  {
    question: "Can we book emcee services separately?",
    answer:
      "Yes, emcee services can be booked as a standalone add-on or as part of complete event management packages.",
  },
];

export const contactDetails = {
  phoneLabel: "+852 9404 9327",
  phoneHref: "tel:+85294049327",
  whatsappHref: "https://wa.me/85294049327?text=Hi%2C%20I%20would%20like%20to%20book%20an%20event%20consultation.",
  email: "rjleventshk@gmail.com",
  calendly: "https://calendly.com/rjleventshk/30min",
  linkedin: "https://www.linkedin.com/in/rebecca-j-learoyd/",
};

export const pastEvents = [
  {
    event: "Consensus 2026",
    year: "2026",
    client: "Coindesk",
    role: "Account Manager (50 Sponsors)",
    location: "Hong Kong",
  },
  {
    event: "Insurance Investor Summit Hong Kong",
    year: "2025",
    client: "InsuranceAsia News",
    role: "Solo Producer & Emcee",
    location: "Hong Kong",
  },
  {
    event: "Digital Marketing Asia Hong Kong",
    year: "2024",
    client: "Marketing-Interactive",
    role: "Producer",
    location: "Hong Kong",
  },
  {
    event: "Digital Marketing Asia Singapore",
    year: "2024",
    client: "Marketing-Interactive",
    role: "Producer",
    location: "Singapore",
  },
  {
    event: "PR Asia",
    year: "2024",
    client: "Marketing-Interactive",
    role: "Producer",
    location: "Asia",
  },
  {
    event: "Lexology Live Hong Kong Awards Dinner",
    year: "2023",
    client: "Law Business Research",
    role: "Event Planner & Organiser (Winner Management)",
    location: "Hong Kong",
  },
  {
    event: "Lexology Live Hong Kong",
    year: "2023",
    client: "Law Business Research",
    role: "Solo Producer & Emcee",
    location: "Hong Kong",
  },
  {
    event: "IPBC Australasia",
    year: "2023",
    client: "Law Business Research",
    role: "Solo Producer & Emcee",
    location: "Australasia",
  },
  {
    event: "IPBC India",
    year: "2023",
    client: "Law Business Research",
    role: "Solo Producer & Emcee",
    location: "India",
  },
  {
    event: "IPBC Australasia",
    year: "2022",
    client: "Law Business Research",
    role: "Solo Producer",
    location: "Australasia",
  },
  {
    event: "IPBC Asia (Tokyo)",
    year: "2022",
    client: "Law Business Research",
    role: "Solo Producer",
    location: "Tokyo",
  },
  {
    event: "Lexology Live Melbourne",
    year: "2022",
    client: "Law Business Research",
    role: "Conference Producer",
    location: "Melbourne",
  },
  {
    event: "Brand Strategy India",
    year: "2020",
    client: "Law Business Research",
    role: "Conference Producer",
    location: "India",
  },
  {
    event: "Lexology Live Mumbai",
    year: "2020",
    client: "Law Business Research",
    role: "Conference Producer",
    location: "Mumbai",
  },
  {
    event: "Lexology Live Singapore",
    year: "2019",
    client: "Law Business Research",
    role: "Conference Producer",
    location: "Singapore",
  },
];

export const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/rebecca-j-learoyd/",
    testId: "footer-linkedin-link",
  },
];